import { createError } from '../util';

class ValidationType {
  constructor() {
    let data = arguments[0] || {};
    this.name = data.name || '';
    this.key = data.key || null;
    this.value = 'value' in data ? data.value : true;
    this.target = 'target' in data ? data.target : false;
    this.type = 'type' in data ? data.type : false;
  }

  get required() {
    return false;
  }

  get comparesField() {
    return false
  }

  createValidationError(attrs) {
    const defaultAttrs = {
      error: 'ValidationError',
    };
    const useAttrs = {
      ...defaultAttrs,
      ...attrs,
    };
    return createError(useAttrs);
  }

  describeValidation(validation) {
    let ret = this.name;
    if (this.value) {
      let value = validation.value;

      if (value !== null) {
        if(validation.type.type && validation.type.type == 'datetime'){
          value = moment(value).utcOffset(value).format('YYYY-MM-DD h:mm a');
        }
        if(validation.type.type && validation.type.type == 'date'){
          value = moment(value).utcOffset(value).format('YYYY-MM-DD');
        }
        if(validation.type.type && validation.type.type == 'time'){
          value = moment(value).utcOffset(value).format('h:mm a');
        }
        ret += ': ' + value;
      } else {
        ret += ': (unspecified)';
      }
    } else if (this.target) {
      if (validation.target !== null) {
        ret += ': "' + validation.target.getField().getLabelText() + '"';
      } else {
        ret += ': (unspecified)';
      }
    }
    return ret;
  }

  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    return errors;
  }
}

export default ValidationType;
